var qr = {};

qr.init = function() {

  qr.setQr();

  // Mobile (2026-08-31): tapping #topNav in any form closes the panel. The
  // panel now clears the nav (CSS below in _qr.scss), so a nav tap is an
  // unambiguous dismiss signal — and with the panel out from under the nav,
  // nav-link taps still navigate normally. touchstart = snappy; no navigation
  // is pending on a plain surface tap, so nothing is cancelled.
  document.addEventListener('touchstart', function(e) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 479px)').matches) {
      return;
    }
    var panel = document.getElementById('quick-reply');
    if (!panel || panel.style.display === 'none') {
      return;   // not on a thread page, or already closed
    }
    if (e.target.closest && e.target.closest('#topNav')) {
      panel.style.display = 'none';
    }
  }, { passive: true });

};

qr.removeQr = function() {
  qrPanel.style.display = 'none';
};

// Keep the panel's initial position inside the viewport. Reads the saved drag
// position (or the old right:25px/top:50px default) and clamps it, using the
// panel's real rendered size so it works at any width.
qr.clampToViewport = function(panel) {
  var margin = 8;

  var prev = panel.style.display;
  panel.style.display = 'block';
  var w = panel.offsetWidth;
  var h = panel.offsetHeight;
  panel.style.display = prev || '';

  var maxLeft = Math.max(margin, window.innerWidth - w - margin);
  var maxTop = Math.max(margin, window.innerHeight - h - margin);

  var left = parseInt(localStorage.getItem('dragLeft'), 10);
  var top = parseInt(localStorage.getItem('dragTop'), 10);
  if (isNaN(left)) left = window.innerWidth - w - 25;   // old default: right:25px
  if (isNaN(top)) top = 50;                             // old default: top:50px

  panel.style.left = Math.min(Math.max(margin, left), maxLeft) + 'px';
  panel.style.top = Math.min(Math.max(margin, top), maxTop) + 'px';
};

qr.showQr = function() {

  // FAST PASS (2026-10-20): opening the quick-reply panel is the intent signal —
  // the gate is shown here, once per page view, instead of after Post bounces.
  if (typeof fastpass !== 'undefined') {
    fastpass.onIntent();
  }

  if (settings.get('qrMode')) {

    if (!qr.isAtTop()) {
      qrPanel.style.display = 'block';
    }

    document.getElementById('qrbody').value = document
      .getElementById('fieldMessage').value;

    // Mobile (2026-08-19): don't ambush the keyboard on open. The panel is
    // top-anchored and compact; the user taps the comment box when they're
    // ready, after attaching files / checking the post being replied to.
    if (!window.matchMedia || !window.matchMedia('(max-width: 479px)').matches) {
      document.getElementById('qrbody').focus();
    }
  } else {

    if (settings.get('scrollPostFormMode')) {
      document.getElementById('fieldMessage').focus();
    }

  }
};

qr.registerSync = function(source, destination, field, event) {

  var sourceElement = document.getElementById(source);
  var destinationElement = document.getElementById(destination);

  destinationElement[field] = sourceElement[field];

  sourceElement.addEventListener(event, function() {
    if (destinationElement) {
      destinationElement[field] = sourceElement[field];
    }
  });

  destinationElement.addEventListener(event, function() {
    sourceElement[field] = destinationElement[field];
  });

};

qr.setQr = function() {

  var flags = document.getElementById('flagsDiv') ? true : false;

  var QRshowname = document.getElementById('fieldName') ? true : false;

  // Layout is ONE structure for every viewport (2026-10-16): the mobile
  // v2/v3 design the operator signed off is now the desktop's too - the
  // classic desktop stack burned three rows (full-width name, subject +
  // unlabeled sage, lone Reply button) inside a 300px panel. Same field IDs
  // either way, so all sync/post/captcha wiring is layout-agnostic; the
  // per-viewport geometry lives in _qr.scss (base rules + <=479px block).
  var textBoard = !document.getElementById('divUpload');

  var qrhtml = '';

  // Position is applied after append via qr.clampToViewport() so it can be
  // measured and kept on-screen (a stale desktop drag position must not park the
  // panel off a phone viewport).
  qrhtml += '<div id="quick-reply">';

  qrhtml += '<div id="post-form-inner">';
  qrhtml += '<table class="post-table"><tbody>';

  qrhtml += '<tr><th>'
  qrhtml += '<span class="handle">';
  qrhtml += '<a id="qrclose" class="close-btn"></a>';
  qrhtml += '{{ lang.quickReply }}</span>';
  qrhtml += '</th></tr>'

  qrhtml = qrhtml.replace("{{ lang.quickReply }}", lang.quickReply);

  // One line: Name + Subject + sage (sage last, after subject). The sage
  // word-label is new on desktop - the classic checkbox sat there unlabeled
  // (operator: "unlabeled sage box"); title carries the upstream Sage pun,
  // the visible label is lang.sage.
  qrhtml += '<tr><td colspan="2" class="qr-line">';
  if (QRshowname) {
    qrhtml += '<input id="qrname" type="text"'
    qrhtml += ' maxlength="35" autocomplete="off" placeholder="Name">';
  }
  qrhtml += '<input id="qrsubject" class="qr-subj" type="text" maxlength="100"'
  qrhtml += ' autocomplete="off" placeholder="{{ lang.subject }}">';
  qrhtml += '<label class="qr-sagewrap"><input id="qrsage" type="checkbox"'
  qrhtml += ' title="{{ lang.sage }}">&nbsp;{{ lang.sage }}</label>';
  qrhtml += '</td></tr>';
  qrhtml = qrhtml.replace("{{ lang.subject }}", lang.subject);
  // split/join, not replace(): the token appears TWICE (title + label) and
  // String.replace with a string arg replaces only the FIRST occurrence -
  // first ship shipped the visible label as the raw '{{ lang.sage }}'
  // literal (operator report 2026-10-16). split/join is also safe on the old
  // iOS targets this site keeps; replaceAll is not.
  qrhtml = qrhtml.split("{{ lang.sage }}").join(lang.sage);

  qrhtml += '<tr><td colspan="10"><textarea id="qrbody" rows="5" placeholder="{{ lang.comment }}">';
  qrhtml += '</textarea></td></tr> ';
  qrhtml = qrhtml.replace("{{ lang.comment }}", lang.comment);

  qrhtml += '<tr style="display:none;"><td colspan="2">';
  qrhtml += '<input id="qrpassword" type="password" placeholder="{{ lang.password }}"></td></tr>';
  qrhtml = qrhtml.replace("{{ lang.password }}", lang.password);

  var noFlagDiv = document.getElementById('noFlagDiv');

  if (noFlagDiv) {
    qrhtml += '<tr><td colspan="2"><input type="checkbox" ';
    qrhtml += 'id="qrcheckboxNoFlag" class="postingCheckbox">';
    qrhtml += '<label for="qrcheckboxNoFlag" class="spoilerCheckbox">';
    qrhtml += '{{ lang.noLocation2 }}</label></td></tr>';
    qrhtml = qrhtml.replace("{{ lang.noLocation2 }}", lang.noLocation2);
  }

  if (!api.hiddenCaptcha) {

    var parts = document.getElementsByClassName('captchaImage')[0].src
      .split('/');

    var lastPart = '/' + parts[parts.length - 1];

    /* 2026-08-27: wrap in .captchaImageWrap so the ↻ reload badge (top-level
       rule in _posting.scss) anchors on the quick-reply captcha too — same
       pattern as the post form. Click-reload wiring below is unchanged. */
    qrhtml += '<tr><td colspan="2"><span class="captchaImageWrap"><img src="' + lastPart;
    qrhtml += '"id="captchaImageQR" class="captchaImage" alt="captcha"></span></td></tr>';

    qrhtml += '<tr><td><input type="text" class="captchaField" ';
    qrhtml += 'id="QRfieldCaptcha" placeholder="{{ lang.answer }}"></td>';
    qrhtml = qrhtml.replace("{{ lang.answer }}", lang.answer);
    qrhtml += '</tr>';
  }

  qrhtml += '<tr style="display:none;"><td colspan="2"><input type="checkbox" ';
  qrhtml += 'id="qralwaysUseBypassCheckBox" class="postingCheckbox">';
  qrhtml += '<label for="qralwaysUseBypassCheckBox" class="spoilerCheckbox">';
  qrhtml += 'Make sure I have a block bypass</label></td></tr>';

  if (flags) {
    qrhtml += '<tr><td colspan="2"><div id="qrFlagsDiv"></div></td></tr>';
  }

  if (!textBoard) {
    // Attach + Reply share the top line (mobile v3 layout, now on desktop
    // too): fixed-height dropzone + button, file chips stack BELOW the line
    // so neither element stretches when chips appear (_qr.scss; the panel
    // grows around them). Stray double-quote in the upstream button line
    // (type="button">) cleaned on the way (known cosmetic, see handoff doc).
    qrhtml += '<tr><td colspan="2" class="qr-attachrow">';
    qrhtml += '<div class="dz-reply-line">';
    qrhtml += '<div class="dropzone" id="dropzoneQr">';
    qrhtml += '{{ lang.dragFilesToUploadOrBrClickHereToSelectThem }}</div>';
    qrhtml += '<button accesskey="s" id="qrbutton" type="button">{{ lang.reply }}</button>';
    qrhtml += '</div>';
    qrhtml += '<div id="selectedDivQr"></div>';
    qrhtml += '</td></tr>';
    // File limits (2026-08-30): same caption as the main form's
    // .file-limits-line (postingForm.njk). Values come from the engine-filled
    // post-form spans (labelMaxFiles / labelMaxFileSize are threadPage
    // prebuiltFields, inner) — read at build time; if the spans are missing
    // the line is skipped entirely.
    var qrMaxSize = document.getElementById('labelMaxFileSize');
    var qrMaxFiles = document.getElementById('labelMaxFiles');
    if (qrMaxSize && qrMaxFiles) {
      qrhtml += '<tr><td colspan="2" class="qr-file-limits">';
      // id'd wrapper (NOT an appended span): the readout overwrites the size
      // label in place so the row width never changes (postCommon.updateUploadTotal).
      qrhtml += '<span id="qrLabelMaxFileSize">' + qrMaxSize.textContent + '</span> {{ lang.maxFileSize }} · ';
      qrhtml += qrMaxFiles.textContent + ' {{ lang.maxNumberOfFilesPerPost }} · ';
      qrhtml += '{{ lang.allowedFileTypes1 }}</td></tr>';
    }
    qrhtml = qrhtml.replace("{{ lang.dragFilesToUploadOrBrClickHereToSelectThem }}", lang.dragFilesToUploadOrBrClickHereToSelectThem);
    qrhtml = qrhtml.replace("{{ lang.spoiler }}", lang.spoiler);
    qrhtml = qrhtml.replace("{{ lang.maxFileSize }}", lang.maxFileSize)
                   .replace("{{ lang.maxNumberOfFilesPerPost }}", lang.maxNumberOfFilesPerPost)
                   .replace("{{ lang.allowedFileTypes1 }}", lang.allowedFileTypes1);
  } else {
    // Text board: no attach row, Reply on its own line (was desktop's
    // classic row; mobile v3 already did this).
    qrhtml += '<tr><td colspan="2">';
    qrhtml += '<button accesskey="s" id="qrbutton" type="button">{{ lang.reply }}</button>';
    qrhtml += '</td></tr>';
  }

  qrhtml = qrhtml.replace("{{ lang.reply }}", lang.reply);

  qrhtml += '</tbody> </table></div></div>';

  qrPanel = document.createElement('div');
  qrPanel.innerHTML = qrhtml;
  qrPanel = qrPanel.children[0];

  draggable.setDraggable(qrPanel, qrPanel.getElementsByClassName('handle')[0]);

  document.body.appendChild(qrPanel);

  qr.clampToViewport(qrPanel);

  // The quick-reply panel follows the comment box, LIVE (2026-10-24, third cut).
  // The three failed cuts define the constraints: (1) the CSS-only fit-content version
  // could not follow at all (a table column contributes the textarea's INTRINSIC
  // (cols) width to shrink-wrap, never the dragged width) and left the panel wider at
  // rest than the signed-off 300px layout; (2) the mouseup version followed only on
  // release, so mid-drag the box was clipped at the panel edge and the resize handle
  // vanished into the clipped area — the operator's "drag into the void, then snap";
  // (3) clamping the box inside the observer made the UA gesture and JS fight over one
  // property every pixel, so the box flashed two widths at once. Rule that came out of
  // it: the follow writes a DIFFERENT element (the panel), and every limit on the box
  // is CSS-enforced, because the native gesture honors min/max and stops.
  // So CSS keeps the 300px resting layout + the min/max clamps, and JS drives the
  // panel width from the box DURING the drag. CSS `resize` fires no events, so live
  // tracking = ResizeObserver on the box (the spec'd way to observe a CSS-resize drag;
  // Chrome/Safari 13.4+), with the mouseup listener kept as the fallback for clients
  // that lack it.
  // Every floor is MEASURED at open, not a px constant: the box's resting size is what
  // "not smaller than its default" means, and it depends on theme/font/viewport (the
  // 288px constant was 24px+ off, and any specified width on the box feeds back into
  // the panel's shrink-wrap, which is what widened the resting box).
  // The panel is display:none at this line (setQr sets it before the append), so
  // measuring needs the same display toggle qr.clampToViewport uses. The panel is
  // position:fixed at an inline left, so every width change re-anchors it. Phones:
  // the <=479px block sets resize:none, so no drag can start there.
  var qrResizeField = document.getElementById('qrbody');
  if (qrResizeField) {
    var qrPrevDisplay = qrPanel.style.display;
    qrPanel.style.display = 'block';
    var qrBoxDefaultWidth = qrResizeField.offsetWidth;
    var qrBoxDefaultHeight = qrResizeField.offsetHeight;
    var qrPanelChromeWidth = qrPanel.offsetWidth - qrBoxDefaultWidth;
    qrPanel.style.display = qrPrevDisplay || '';

    var qrSyncPanelWidth = function() {
      var boxW = qrResizeField.offsetWidth;
      qrPanel.style.width = (boxW + qrPanelChromeWidth) + 'px';
      // The panel's CSS max-width:min(90vw,720px) is the OUTER clamp (it caps the
      // panel's used width). The box gets the matching cap as its OWN max-width, so
      // the native gesture stops there too instead of dragging into the clipped area
      // past the panel edge. Idempotent: the value only moves with the viewport, never
      // during a drag, so writing it here cannot fight the gesture.
      qrResizeField.style.maxWidth = (Math.min(Math.floor(window.innerWidth * 0.9),
          720) - qrPanelChromeWidth) + 'px';
      qr.clampToViewport(qrPanel);
    };

    // Limits are handed to CSS ONCE, as the box's own min-width/min-height: the native
    // resize gesture honors min/max, so a drag STOPS at the limit. The previous cut
    // clamped the box INSIDE the ResizeObserver callback, so the UA gesture and JS
    // wrote the same property every pixel of a left-drag and the box flashed, two
    // widths overlapping (operator report 2026-10-24). A limit the UA enforces cannot
    // fight the gesture; a limit JS re-applies always does.
    // These are safe as CSS floors ONLY because the panel is width:300px now: under the
    // old fit-content panel, any specified width on the box fed back into the panel's
    // shrink-wrap and widened the resting layout.
    qrResizeField.style.minWidth = qrBoxDefaultWidth + 'px';
    qrResizeField.style.minHeight = qrBoxDefaultHeight + 'px';

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function() {
        qrSyncPanelWidth();
      }).observe(qrResizeField);
    }
    qrResizeField.addEventListener('mouseup', qrSyncPanelWidth);
  }

  document.getElementById('qrclose').onclick = qr.removeQr;
  document.getElementById('qrbutton').onclick = thread.postReply;

  qr.registerSync('checkboxSage', 'qrsage', 'checked', 'change');
  qr.registerSync('fieldSubject', 'qrsubject', 'value', 'input');
  qr.registerSync('fieldMessage', 'qrbody', 'value', 'input');
  qr.registerSync('fieldPostingPassword', 'qrpassword', 'value', 'input');
  qr.registerSync('alwaysUseBypassCheckBox', 'qralwaysUseBypassCheckBox',
      'checked', 'change');

  if (noFlagDiv) {
    qr.registerSync('checkboxNoFlag', 'qrcheckboxNoFlag', 'checked', 'change');
  }

  if (!textBoard) {
    postCommon.setDragAndDrop(true);

    for (var i = 0; i < selectedDiv.childNodes.length; i++) {
      var originalCell = selectedDiv.childNodes[i];
      var clonedCell = originalCell.cloneNode(true);

      clonedCell.getElementsByClassName('removeButton')[0].onclick = originalCell
          .getElementsByClassName('removeButton')[0].onclick;

      selectedDivQr.appendChild(clonedCell);
    }
  }

  if (flags) {

    document.getElementById('qrFlagsDiv').innerHTML = document
        .getElementById('flagsDiv').innerHTML.replace('flagCombobox',
        'qrFlagCombobox');

    qrFlagCombo = document.getElementById('qrFlagCombobox');

    postCommon.setFlagPreviews(qrFlagCombo)

    qr.registerSync('flagCombobox', 'qrFlagCombobox', 'value', 'change');

  }

  if (QRshowname) {
    qr.registerSync('fieldName', 'qrname', 'value', 'input');
  }

  if (!api.hiddenCaptcha) {
    qr.registerSync('fieldCaptcha', 'QRfieldCaptcha', 'value', 'input');
    var captchaImageQR = document.getElementById('captchaImageQR');
    if (captchaImageQR) {
      captchaImageQR.onclick = captchaUtils.reloadCaptcha;
    }
  }

};

qr.hideIfAtTop = function() {

  if (qr.isAtTop() || qrPanel.hidden)
    qrPanel.style.display = 'none';
  else
    qrPanel.style.display = 'block';

  // Work with thread update...
  if (!thread.unreadPosts) {
    return;
  }

  var rect = thread.lastPost.getBoundingClientRect();

  if (rect.bottom < window.innerHeight) {
    thread.unreadPosts = 0;

    document.title = thread.originalTitle;
  }
}

qr.isAtTop = function() {

  var postingForm = document.getElementById('postingForm');

  if (!postingForm)
    return false;

  var rect = postingForm.getBoundingClientRect();

  if (rect.bottom < window.pageYOffset)
    return false;
  else
    return true;

}

qr.setQRReplyText = function(text) {

  var qrReplyButton = document.getElementById('qrbutton');

  if (qrReplyButton) {
    qrReplyButton.innerHTML = text;
  }

};

qr.clearQRAfterPosting = function() {

  var qrMessageField = document.getElementById('qrbody');

  if (!qrMessageField) {
    return;
  }

  document.getElementById('qrsubject').value = '';
  qrMessageField.value = '';
  document.getElementById('qrsage').checked = false;

};

qr.setQRReplyEnabled = function(enabled) {

  var qrReplyButton = document.getElementById('qrbutton');

  if (qrReplyButton) {
    qrReplyButton.disabled = !enabled;
  }

};

qr.init();
